import cn from '@/utils/cn'
import timeUtils from '@/utils/time.utils'
import css from './reportTableHeader.module.css'
import { ReactNode } from 'react'

interface IProps {
  days: Date[]
  scrollWidth: number
  loading: boolean
  hoverCol: number | null
  onHoverColChange: (v: number) => void
  leadingCell?: ReactNode
}

const ReportTableHeader = (props: IProps) => {
  const renderHeaderCells = () => {
    return props.days.map((date, colIndex) => (
      <div
        key={colIndex}
        className={css.headerCell}
        data-is-today={timeUtils.isToday(date)}
        data-is-monday={colIndex % 7 === 0}
        data-loading={props.loading}
        data-hover={colIndex === props.hoverCol}
        data-leading={Boolean(props.leadingCell)}
        onMouseOver={() => props.onHoverColChange(colIndex)}
        onMouseLeave={() => props.onHoverColChange(null)}
      >
        <div className={cn('text-sm', css.headerCellTextDay)}>{timeUtils.formatDate(date, 'EEEEEE')}</div>
        <div className={cn('text-nm', css.headerCellTextDate)}>{date.getDate()}</div>
      </div>
    ))
  }

  return (
    <div className={css.headerRow} style={{ paddingRight: `${props.scrollWidth}px` }}>
      {Boolean(props.leadingCell) && <div className={css.sortCell}>{props.leadingCell}</div>}
      {renderHeaderCells()}
    </div>
  )
}

export default ReportTableHeader
